import React from 'react';
const AutomationManualTriggersGlyph = ({
  label
}) => /*#__PURE__*/React.createElement("svg", {
  "aria-label": label,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14 5L10 19",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 5L7 12H17L10 19",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
export default AutomationManualTriggersGlyph;